import { CaseStatusEnum, DisplayableCaseStatus } from '@/citator/schema/case-status-schema'

export const kCaseStatusDefinitions: Record<DisplayableCaseStatus, { label: string; heading: string; body: string[] }> = {
  [CaseStatusEnum.likely_good]: {
    label: 'No flags detected',
    heading: 'No negative treatment detected',
    body: ['This case has been evaluated through our citator. No negative or cautionary treatment has been detected.'],
  },
  [CaseStatusEnum.likely_bad]: {
    label: 'Negative treatment',
    heading: 'Negative treatment detected',
    body: [
      'A subsequent court has directly contradicted or abrogated a holding in this case. One or more legal conclusions is no longer valid.',
      'Do not cite without confirming which holdings remain good law.',
    ],
  },
  [CaseStatusEnum.overruling_risk]: {
    label: 'Overruling risk',
    heading: 'Overruling risk detected',
    body: [
      'This case materially relied on precedent that was later overturned or vacated.',
      'It may still support your argument; confirm that the specific holding you need has not been affected.',
    ],
  },
  [CaseStatusEnum.caution]: {
    label: 'Use caution',
    heading: 'Use caution: Mixed treatment detected',
    body: [
      'This case has received mixed treatment by later courts — questioned, distinguished, or declined to follow in certain contexts — without being overturned.',
      'It may still support your argument; confirm the specific holding you need has not been affected.',
    ],
  },
}
